const SAMPLE_CONSENTS = [
  { treatmentName: 'Root Canal — Tooth #14', patientName: 'Giorgi Beridze', consentStatus: 'Signed', dateSigned: 'Mar 15, 2026' },
  { treatmentName: 'Crown Placement — Tooth #30', patientName: 'Nino Kvaratskhelia', consentStatus: 'Pending', dateSigned: null },
  { treatmentName: 'Implant — Tooth #19', patientName: 'Luka Maisuradze', consentStatus: 'Signed', dateSigned: 'Mar 10, 2026' },
  { treatmentName: 'Wisdom Tooth Extraction', patientName: 'Ana Tsulukidze', consentStatus: 'Expired', dateSigned: 'Jan 05, 2026' },
  { treatmentName: 'Teeth Whitening', patientName: 'Davit Janelidze', consentStatus: 'Signed', dateSigned: 'Mar 18, 2026' }
]

export const consent = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: {
    display: 'none',
    show: (() => {
      let d = false
      return (el, s) => {
        if (!d) {
          d = true
          Promise.resolve().then(() => s.root.update({
            activeTab: 'consent',
            consentView: 'new',
            consentChecks: {}
          }))
        }
        return false
      }
    })()
  },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',
    TopBar: {},
    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      PageHeader: {
        flow: 'x',
        align: 'center space-between',
        flexWrap: 'wrap',
        gap: 'Z',
        PageTitle: {
          tag: 'h2',
          text: '{{ informedConsent | polyglot }}',
          fontSize: 'B',
          fontWeight: '700',
          color: 'inkText'
        }
      },

      ViewTabs: {
        flow: 'x',
        gap: 'Z',
        borderBottom: '1px solid inkBorder',
        paddingBottom: 'Y',
        NewConsentTab: {
          text: '{{ newConsent | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.consentView === 'new' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.consentView === 'new' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ consentView: 'new' })
        },
        HistoryTab: {
          text: '{{ consentHistory | polyglot }}',
          fontSize: 'Z',
          fontWeight: '600',
          padding: 'Y Z',
          cursor: 'pointer',
          color: (el, s) => s.root.consentView === 'history' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.consentView === 'history' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ consentView: 'history' })
        }
      },

      NewConsentView: {
        if: (el, s) => s.root.consentView === 'new',
        flow: 'y',
        gap: 'B',

        PatientBanner: {
          state: {
            name: 'Giorgi Beridze',
            age: 34,
            allergies: [{ label: 'Penicillin', severity: 'severe' }],
            insurance: 'Aldagi',
            lastVisit: 'Mar 15, 2026'
          }
        },

        InformedConsentForm: {
          state: { treatmentName: 'Root Canal Treatment — Tooth #14' }
        },

        ESignature: {}
      },

      HistoryView: {
        if: (el, s) => s.root.consentView === 'history',
        flow: 'y',
        gap: 'Z',

        ConsentList: {
          flow: 'y',
          gap: 'Z',
          childExtends: 'ConsentCard',
          childrenAs: 'state',
          children: () => SAMPLE_CONSENTS
        }
      }
    }
  }
}
